const BASE_URL = 'https://attendance.kervolt.com/api';
// const BASE_URL = 'https://runbizops.com/api';

export const ENDPOINTS = {
    AUTH: {
        LOGIN: `${BASE_URL}/authentication`,
        REFRESH: `${BASE_URL}/auth/refresh-token`,
        IMPERSONATE: (userId: string) => `${BASE_URL}/authentication/impersonate/${userId}`,
        VERIFY_TWO_FACTOR: `${BASE_URL}/authentication/verify`,
    },
    IMPERSONATION_GRANT: {
        MY: `${BASE_URL}/impersonation-grant/my`,
        AVAILABLE: `${BASE_URL}/impersonation-grant/available`,
        BASE: `${BASE_URL}/impersonation-grant`,
    },
    USER_PROFILE: {
        LOGGED_IN_USER_PROFILE: `${BASE_URL}/user-profile/logged-in-user-profile`,
        UPDATE_PROFILE: (id: string) => `${BASE_URL}/user-profile/${id}`,
        BY_USER: (userId: string) => `${BASE_URL}/user-profile/user/${userId}`,
    },
    TWO_FACTOR: {
        SETUP: `${BASE_URL}/user/2fa/setup`,
        ENABLE: `${BASE_URL}/user/2fa/enable`,
        DISABLE: `${BASE_URL}/user/2fa/disable`,
        REGENERATE_BACKUP_CODES: `${BASE_URL}/user/2fa/backup-codes/regenerate`,
        STATUS: `${BASE_URL}/user/2fa/status`,
        ADMIN_RESET: (userId: string) => `${BASE_URL}/user/2fa/admin/reset/${userId}`,
        ADMIN_BLOCK_BACKUP_CODES: (userId: string) => `${BASE_URL}/user/2fa/admin/backup-codes/block/${userId}`,
        ADMIN_UNBLOCK_BACKUP_CODES: (userId: string) => `${BASE_URL}/user/2fa/admin/backup-codes/unblock/${userId}`,
        ADMIN_STATUS: (userId: string) => `${BASE_URL}/user/2fa/admin/status/${userId}`,
    },
    USER: {
        BASE: `${BASE_URL}/user`,
        INSTITUTION_USERS: `${BASE_URL}/user/institution-users`,
        UPDATE_TYPE: `${BASE_URL}/user/update-type`,
        UPDATE_PASSWORD: `${BASE_URL}/user/update-password`,
        LANGUAGE: `${BASE_URL}/user/me/language`,
        RESET_PASSWORD: (userId: string, institutionId: string) => `${BASE_URL}/user/${userId}/institution/${institutionId}/reset-user-password`,
        UPDATE_USERNAME: (userId: string) => `${BASE_URL}/user/update-username/${userId}`,
        CHECK_USERNAME: `${BASE_URL}/user/check-username-available`,
        TOGGLE_ACTIVE: (id: string) => `${BASE_URL}/user/toggle-active/${id}`,
        DELETE: (id: string) => `${BASE_URL}/user/${id}`,
        PERMISSIONS: (userId: string, institutionId: string) =>
            `${BASE_URL}/user/${userId}/permissions/${institutionId}`,
    },
    INSTITUTION: {
        BASE: `${BASE_URL}/institution`,
        LOGGED_IN_USER_INSTITUTIONS: `${BASE_URL}/institution/logged-in-user-institutions`,
        CHECK_CODE_UNIQUENESS: `${BASE_URL}/institution/check-code-unique`,
        UPDATE: (id: string) => `${BASE_URL}/institution/${id}`,
        DELETE: (id: string) => `${BASE_URL}/institution/${id}`,
        TOGGLE_ACTIVE: (id: string) => `${BASE_URL}/institution/toggle-active/${id}`,
        BY_USER_ID: (userId: string) => `${BASE_URL}/institution/user/${userId}`,
        PREMIUM_DASHBOARD: (id: string) => `${BASE_URL}/institution/${id}/premium-dashboard`,
        ENABLED_MODULES: (id: string) => `${BASE_URL}/institution/${id}/enabled-modules`,
        ACCOUNTING_FEE: (id: string) => `${BASE_URL}/institution/${id}/accounting-fee`,
        PLAN: (id: string) => `${BASE_URL}/institution/${id}/plan`,
    },
    INSTITUTION_SETTINGS: {
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/institution-settings/institution/${institutionId}`,
        WEEKEND_DAYS: (institutionId: string) => `${BASE_URL}/institution-settings/institution/${institutionId}/weekend-days`,
        TWO_FACTOR_POLICY: (institutionId: string) => `${BASE_URL}/institution-settings/institution/${institutionId}/two-factor-policy`,
    },
    ATTENDANCE: {
        BASE: `${BASE_URL}/attendance`,
        LOGGED_IN_USER_ATTENDANCE: `${BASE_URL}/attendance/logged-in-user-attendance`,
        CLOCK_IN: `${BASE_URL}/attendance/in`,
        CLOCK_OUT: `${BASE_URL}/attendance/out`,
        UPDATE: (id: string) => `${BASE_URL}/attendance/${id}`,
        EMPLOYEE_ATTENDANCE: (employeeUserId: string) =>
            `${BASE_URL}/attendance/employee/${employeeUserId}`,
        INSTITUTION_TODAY: (institutionId: string) =>
            `${BASE_URL}/attendance/institution/${institutionId}/today`,
        MONTHLY_REPORT: (institutionId: string) =>
            `${BASE_URL}/attendance/institution/${institutionId}/monthly-report`,
    },
    DEPARTMENT: {
        BASE: `${BASE_URL}/department`,
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/department/institution/${institutionId}`,
        BY_ID: (id: string) => `${BASE_URL}/department/${id}`,
        UPDATE: (id: string) => `${BASE_URL}/department/${id}`,
        DELETE: (id: string) => `${BASE_URL}/department/${id}`,
        USERS: (departmentId: string) => `${BASE_URL}/department/${departmentId}/users`,
        TOGGLE_ADMIN: (departmentId: string, userId: string) => `${BASE_URL}/department/${departmentId}/users/${userId}/toggle-admin`,
    },
    HOLIDAY: {
        BASE: `${BASE_URL}/holiday`,
        HOLIDAY_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/holiday/institution/${institutionId}`,
        DELETE: (id: string) => `${BASE_URL}/holiday/${id}`,
    },
    LEAVE_APPLICATION: {
        BASE: `${BASE_URL}/leave-application`,
        LOGGED_IN_USER_APPLICATION_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/leave-application/logged-in-user/institution/${institutionId}`,
        ALL_APPLICATION_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/leave-application/institution/${institutionId}`,
        CANCEL: (id: string) => `${BASE_URL}/leave-application/${id}/cancel`,
        APPROVE: (id: string) => `${BASE_URL}/leave-application/${id}/approve`,
        REJECT: (id: string) => `${BASE_URL}/leave-application/${id}/reject`
    },
    LEAVE_TYPE: {
        BASE: `${BASE_URL}/leave-type`,
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/leave-type/institution/${institutionId}`,
        UPDATE_DOC_REQUIREMENT: (id: string) => `${BASE_URL}/leave-type/${id}/document-requirement`,
        UPDATE_PAID: (id: string) => `${BASE_URL}/leave-type/${id}/paid`,
        SET_ACTIVE: (id: string) => `${BASE_URL}/leave-type/${id}/active`
    },
    LEAVE_DOCUMENT: {
        DOWNLOAD: (id: string) => `${BASE_URL}/leave-document/${id}/download`,
        BY_APPLICATION: (applicationId: string) => `${BASE_URL}/leave-document/leave-application/${applicationId}`,
    },
    EMPLOYEE_DOCUMENT: {
        UPLOAD: `${BASE_URL}/employee-document/upload`,
        UPLOAD_FOR_USER: (userId: string) => `${BASE_URL}/employee-document/upload/user/${userId}`,
        MY_DOCUMENTS: `${BASE_URL}/employee-document/my-documents`,
        BY_USER: (userId: string) => `${BASE_URL}/employee-document/user/${userId}`,
        DOWNLOAD: (id: string) => `${BASE_URL}/employee-document/${id}/download`,
    },
    LEAVE_POLICY: {
        BASE: `${BASE_URL}/leave-policy`,
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/leave-policy/institution/${institutionId}`,
        SET_ACTIVE: (id: string) => `${BASE_URL}/leave-policy/${id}/active`
    },
    USER_LEAVE_ALLOCATION: {
        BASE: `${BASE_URL}/user-leave-allocation`,
        BY_INSTITUTION_AND_FISCAL_YEAR: (institutionId: string, fiscalYear: number) =>
            `${BASE_URL}/user-leave-allocation/institution/${institutionId}/fiscal-year/${fiscalYear}`,
        DELETE: (id: string) => `${BASE_URL}/user-leave-allocation/${id}`
    },
    LEAVE_BALANCE: {
        MY_BALANCE: (institutionId: string) => `${BASE_URL}/leave-balance/my-balance/institution/${institutionId}`,
        ALL_USER_BALANCES: (institutionId: string) => `${BASE_URL}/leave-balance/institution/${institutionId}`
    },
    PUBLIC: {
        CHECK_CODE_UNIQUENESS: `${BASE_URL}/public/institution/check-code-unique`,
        INSTITUTION_CREATE: `${BASE_URL}/public/institution`
    },
    ACCOUNTING: {
        ACCOUNTS: (institutionId: string) => `${BASE_URL}/accounting/institution/${institutionId}/accounts`,
        ACCOUNT: (institutionId: string, accountId: string) => `${BASE_URL}/accounting/institution/${institutionId}/accounts/${accountId}`,
        ENTRIES: (institutionId: string) => `${BASE_URL}/accounting/institution/${institutionId}/entries`,
        ENTRY: (institutionId: string, entryId: string) => `${BASE_URL}/accounting/institution/${institutionId}/entries/${entryId}`,
        REVERSE: (institutionId: string, entryId: string) => `${BASE_URL}/accounting/institution/${institutionId}/entries/${entryId}/reverse`,
        MONEY_IN: (institutionId: string) => `${BASE_URL}/accounting/institution/${institutionId}/money-in`,
        MONEY_OUT: (institutionId: string) => `${BASE_URL}/accounting/institution/${institutionId}/money-out`,
        TRANSFER: (institutionId: string) => `${BASE_URL}/accounting/institution/${institutionId}/transfer`,
        OPENING_BALANCES: (institutionId: string) => `${BASE_URL}/accounting/institution/${institutionId}/opening-balances`,
        OVERVIEW: (institutionId: string) => `${BASE_URL}/accounting/institution/${institutionId}/overview`,
        RETRY_POSTING: (institutionId: string, kind: string, id: string) => `${BASE_URL}/accounting/institution/${institutionId}/failed-postings/${kind}/${id}/retry`,
        TRIAL_BALANCE: (institutionId: string) => `${BASE_URL}/accounting/institution/${institutionId}/reports/trial-balance`,
        PROFIT_LOSS: (institutionId: string) => `${BASE_URL}/accounting/institution/${institutionId}/reports/profit-loss`,
        BALANCE_SHEET: (institutionId: string) => `${BASE_URL}/accounting/institution/${institutionId}/reports/balance-sheet`,
        LEDGER: (institutionId: string) => `${BASE_URL}/accounting/institution/${institutionId}/reports/ledger`,
        CLOSING: (institutionId: string) => `${BASE_URL}/accounting/institution/${institutionId}/closing`,
        CLOSE_MONTH: (institutionId: string, year: number, month: number) => `${BASE_URL}/accounting/institution/${institutionId}/closing/${year}/${month}/close`,
        CLOSE_THROUGH: (institutionId: string, year: number, month: number) => `${BASE_URL}/accounting/institution/${institutionId}/closing/${year}/${month}/close-through`,
        YEAR_CLOSING: (institutionId: string) => `${BASE_URL}/accounting/institution/${institutionId}/closing/years`,
        CLOSE_YEAR: (institutionId: string, yearEnd: string) => `${BASE_URL}/accounting/institution/${institutionId}/closing/years/${yearEnd}/close`,
        REOPEN_YEAR: (institutionId: string, yearEnd: string) => `${BASE_URL}/accounting/institution/${institutionId}/closing/years/${yearEnd}/reopen`,
        REOPEN_MONTH: (institutionId: string, year: number, month: number) => `${BASE_URL}/accounting/institution/${institutionId}/closing/${year}/${month}/reopen`,
    },
    SEGMENT: {
        BASE: `${BASE_URL}/segment`,
        LIST_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/segment/institution/${institutionId}`,
        BY_ID: (id: string) => `${BASE_URL}/segment/${id}`,
        UPDATE: (id: string) => `${BASE_URL}/segment/${id}`,
    },
    ALLOCATION_RULE: {
        BASE: `${BASE_URL}/allocation-rule`,
        UPDATE: (id: string) => `${BASE_URL}/allocation-rule/${id}`,
    },
    SEGMENT_SETTINGS: {
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/segment-settings/institution/${institutionId}`,
        UPDATE: (institutionId: string) => `${BASE_URL}/segment-settings/institution/${institutionId}`,
    },
    LEDGER_CLOSE_SETTINGS: {
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/ledger-close-settings/institution/${institutionId}`,
        UPDATE: (institutionId: string) => `${BASE_URL}/ledger-close-settings/institution/${institutionId}`,
    },
    TRANSACTION: {
        BASE: `${BASE_URL}/transaction`,
        LIST_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/transaction/institution/${institutionId}`,
        BY_ID: (id: string) => `${BASE_URL}/transaction/${id}`,
        DELETE: (id: string) => `${BASE_URL}/transaction/${id}`,
    },
    DASHBOARD: {
        INSTITUTION: (institutionId: string) => `${BASE_URL}/dashboard/institution/${institutionId}`,
        MY_SUMMARY: (institutionId: string) => `${BASE_URL}/dashboard/my-summary/institution/${institutionId}`,
        MY_TEAM_TODAY: (institutionId: string) => `${BASE_URL}/dashboard/my-team/today/institution/${institutionId}`,
        ATTENDANCE_STATUS_USERS: (institutionId: string, status: string) =>
            `${BASE_URL}/dashboard/institution/${institutionId}/attendance-status/${status}`,
        ATTENDANCE_SUMMARY: (institutionId: string) =>
            `${BASE_URL}/dashboard/attendance/summary/institution/${institutionId}`,
        LEAVE_SUMMARY: (institutionId: string) =>
            `${BASE_URL}/dashboard/leave/summary/institution/${institutionId}`,
        PEOPLE_SUMMARY: (institutionId: string) =>
            `${BASE_URL}/dashboard/people/summary/institution/${institutionId}`,
        ACTION_CENTER: (institutionId: string) =>
            `${BASE_URL}/dashboard/action-center/institution/${institutionId}`,
        ATTENDANCE_KPIS: (institutionId: string) =>
            `${BASE_URL}/dashboard/attendance/kpis/institution/${institutionId}`,
        ATTENDANCE_COMPOSITION: (institutionId: string) =>
            `${BASE_URL}/dashboard/attendance/composition/institution/${institutionId}`,
        ATTENDANCE_ARRIVALS: (institutionId: string) =>
            `${BASE_URL}/dashboard/attendance/arrivals/institution/${institutionId}`,
        ATTENDANCE_WEEKDAY: (institutionId: string) =>
            `${BASE_URL}/dashboard/attendance/weekday/institution/${institutionId}`,
        ATTENDANCE_TOP_LATE: (institutionId: string) =>
            `${BASE_URL}/dashboard/attendance/top-late/institution/${institutionId}`,
        ATTENDANCE_TOP_OT: (institutionId: string) =>
            `${BASE_URL}/dashboard/attendance/top-ot/institution/${institutionId}`,
        ATTENDANCE_DEPARTMENT: (institutionId: string) =>
            `${BASE_URL}/dashboard/attendance/department/institution/${institutionId}`,
        ATTENDANCE_TODAY_LOG: (institutionId: string) =>
            `${BASE_URL}/dashboard/attendance/today-log/institution/${institutionId}`,
        PAYROLL_SUMMARY: (institutionId: string) =>
            `${BASE_URL}/dashboard/payroll/summary/institution/${institutionId}`,
        LAYOUT: (institutionId: string, boardKey = 'home') =>
            `${BASE_URL}/dashboard/layout/institution/${institutionId}?boardKey=${encodeURIComponent(boardKey)}`,
        KPI_TARGETS: (institutionId: string) =>
            `${BASE_URL}/dashboard/kpi-targets/institution/${institutionId}`,
        PAYROLL_TREND: (institutionId: string) =>
            `${BASE_URL}/dashboard/payroll/trend/institution/${institutionId}`,
        PAYROLL_BY_DEPARTMENT: (institutionId: string) =>
            `${BASE_URL}/dashboard/payroll/by-department/institution/${institutionId}`,
        PAYROLL_OVERTIME: (institutionId: string) =>
            `${BASE_URL}/dashboard/payroll/overtime/institution/${institutionId}`,
        LEAVE_TREND: (institutionId: string) =>
            `${BASE_URL}/dashboard/leave/trend/institution/${institutionId}`,
        LEAVE_BY_TYPE: (institutionId: string) =>
            `${BASE_URL}/dashboard/leave/by-type/institution/${institutionId}`,
        PEOPLE_GROWTH: (institutionId: string) =>
            `${BASE_URL}/dashboard/people/growth/institution/${institutionId}`,
    },
    DEVICE_USER: {
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/device-user/institution/${institutionId}`,
        UNMAPPED: (institutionId: string) => `${BASE_URL}/device-user/unmapped/${institutionId}`,
        MAP: (id: string) => `${BASE_URL}/device-user/${id}/map`,
        UNMAP: (id: string) => `${BASE_URL}/device-user/${id}/unmap`,
    },
    DEVICE_API_KEY: {
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/device-api-key/institution/${institutionId}`,
        ROTATE: (id: string) => `${BASE_URL}/device-api-key/${id}/rotate`,
        TOGGLE_ACTIVE: (id: string) => `${BASE_URL}/device-api-key/${id}/toggle-active`,
        DELETE: (id: string) => `${BASE_URL}/device-api-key/${id}`,
    },
    BUDGET: {
        BASE: `${BASE_URL}/budget`,
        LIST_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/budget/institution/${institutionId}`,
        COMPARISON: (institutionId: string) => `${BASE_URL}/budget/institution/${institutionId}/comparison`,
        BY_ID: (id: string) => `${BASE_URL}/budget/${id}`,
        UPDATE: (id: string) => `${BASE_URL}/budget/${id}`,
        DELETE: (id: string) => `${BASE_URL}/budget/${id}`,
    },
    SALARY_COMPONENT: {
        BASE: `${BASE_URL}/salary-component`,
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/salary-component/institution/${institutionId}`,
        UPDATE: (id: string) => `${BASE_URL}/salary-component/${id}`,
        DELETE: (id: string) => `${BASE_URL}/salary-component/${id}`,
        SET_ACCOUNT: (id: string) => `${BASE_URL}/salary-component/${id}/account`,
        SEED_DEFAULTS: (institutionId: string) => `${BASE_URL}/salary-component/institution/${institutionId}/seed-defaults`,
    },
    EMPLOYEE_SALARY: {
        BASE: `${BASE_URL}/employee-salary`,
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/employee-salary/institution/${institutionId}`,
        BY_USER: (institutionId: string, userId: string) => `${BASE_URL}/employee-salary/institution/${institutionId}/user/${userId}`,
        UPDATE: (id: string) => `${BASE_URL}/employee-salary/${id}`,
    },
    PAYROLL_SETTINGS: {
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/payroll-settings/institution/${institutionId}`,
    },
    NOTICE: {
        CREATE: (institutionId: string) => `${BASE_URL}/notice/institution/${institutionId}`,
        UPDATE: (noticeId: string, institutionId: string) => `${BASE_URL}/notice/${noticeId}/institution/${institutionId}`,
        DELETE: (noticeId: string, institutionId: string) => `${BASE_URL}/notice/${noticeId}/institution/${institutionId}`,
        ADMIN_LIST: (institutionId: string) => `${BASE_URL}/notice/institution/${institutionId}/admin`,
        FEED: (institutionId: string) => `${BASE_URL}/notice/institution/${institutionId}/feed`,
        GET: (noticeId: string) => `${BASE_URL}/notice/${noticeId}`,
        MARK_READ: (noticeId: string) => `${BASE_URL}/notice/${noticeId}/read`,
        READERS: (noticeId: string, institutionId: string) => `${BASE_URL}/notice/${noticeId}/institution/${institutionId}/readers`,
        ATTACHMENT: (noticeId: string) => `${BASE_URL}/notice/${noticeId}/attachment`,
    },
    TASK: {
        CREATE: (institutionId: string) => `${BASE_URL}/task/institution/${institutionId}`,
        UPDATE: (taskId: string, institutionId: string) => `${BASE_URL}/task/${taskId}/institution/${institutionId}`,
        DELETE: (taskId: string, institutionId: string) => `${BASE_URL}/task/${taskId}/institution/${institutionId}`,
        MY: (institutionId: string) => `${BASE_URL}/task/institution/${institutionId}/my`,
        ASSIGNED_BY_ME: (institutionId: string) => `${BASE_URL}/task/institution/${institutionId}/assigned-by-me`,
        ADMIN_LIST: (institutionId: string) => `${BASE_URL}/task/institution/${institutionId}/admin`,
        GET: (taskId: string) => `${BASE_URL}/task/${taskId}`,
        UPDATE_STATUS: (taskId: string) => `${BASE_URL}/task/${taskId}/status`,
    },
    APPRAISAL: {
        CYCLES: (institutionId: string) => `${BASE_URL}/appraisal/institution/${institutionId}/cycles`,
        CYCLE: (institutionId: string, cycleId: string) => `${BASE_URL}/appraisal/institution/${institutionId}/cycles/${cycleId}`,
        CRITERIA: (institutionId: string, cycleId: string) => `${BASE_URL}/appraisal/institution/${institutionId}/cycles/${cycleId}/criteria`,
        COPY_CRITERIA: (institutionId: string, cycleId: string, sourceCycleId: string) =>
            `${BASE_URL}/appraisal/institution/${institutionId}/cycles/${cycleId}/criteria/copy-from/${sourceCycleId}`,
        START: (institutionId: string, cycleId: string) => `${BASE_URL}/appraisal/institution/${institutionId}/cycles/${cycleId}/start`,
        CLOSE: (institutionId: string, cycleId: string) => `${BASE_URL}/appraisal/institution/${institutionId}/cycles/${cycleId}/close`,
        PARTICIPANTS: (institutionId: string, cycleId: string) => `${BASE_URL}/appraisal/institution/${institutionId}/cycles/${cycleId}/participants`,
        PARTICIPANT: (institutionId: string, cycleId: string, reviewId: string) =>
            `${BASE_URL}/appraisal/institution/${institutionId}/cycles/${cycleId}/participants/${reviewId}`,
        PARTICIPANT_REVIEWER: (institutionId: string, cycleId: string, reviewId: string) =>
            `${BASE_URL}/appraisal/institution/${institutionId}/cycles/${cycleId}/participants/${reviewId}/reviewer`,
        CYCLE_REVIEWS: (institutionId: string, cycleId: string) => `${BASE_URL}/appraisal/institution/${institutionId}/cycles/${cycleId}/reviews`,
        MY_REVIEWS: (institutionId: string) => `${BASE_URL}/appraisal/institution/${institutionId}/reviews/mine`,
        TO_WRITE: (institutionId: string) => `${BASE_URL}/appraisal/institution/${institutionId}/reviews/to-write`,
        REVIEW: (institutionId: string, reviewId: string) => `${BASE_URL}/appraisal/institution/${institutionId}/reviews/${reviewId}`,
        SELF: (institutionId: string, reviewId: string) => `${BASE_URL}/appraisal/institution/${institutionId}/reviews/${reviewId}/self`,
        SELF_SUBMIT: (institutionId: string, reviewId: string) => `${BASE_URL}/appraisal/institution/${institutionId}/reviews/${reviewId}/self/submit`,
        MANAGER: (institutionId: string, reviewId: string) => `${BASE_URL}/appraisal/institution/${institutionId}/reviews/${reviewId}/manager`,
        MANAGER_SUBMIT: (institutionId: string, reviewId: string) => `${BASE_URL}/appraisal/institution/${institutionId}/reviews/${reviewId}/manager/submit`,
        ACKNOWLEDGE: (institutionId: string, reviewId: string) => `${BASE_URL}/appraisal/institution/${institutionId}/reviews/${reviewId}/acknowledge`,
    },
    PAYROLL: {
        GENERATE: `${BASE_URL}/payroll/generate`,
        LIST: (institutionId: string, year: number, month: number) => `${BASE_URL}/payroll/institution/${institutionId}/year/${year}/month/${month}`,
        BY_ID: (id: string) => `${BASE_URL}/payroll/${id}`,
        FINALIZE: (id: string) => `${BASE_URL}/payroll/${id}/finalize`,
        FINALIZE_ALL: (institutionId: string, year: number, month: number) => `${BASE_URL}/payroll/institution/${institutionId}/year/${year}/month/${month}/finalize`,
        PAYSLIP: (id: string) => `${BASE_URL}/payroll/${id}/payslip`,
        RECORD_PAYMENT: (payrollId: string) => `${BASE_URL}/payroll/${payrollId}/payments`,
        REVERSE_PAYMENT: (paymentId: string) => `${BASE_URL}/payroll/payments/${paymentId}/reverse`,
        PAYMENT_STATUS: (payrollId: string) => `${BASE_URL}/payroll/${payrollId}/payment-status`,
        RETRY_JOURNAL_POST: (paymentId: string) => `${BASE_URL}/payroll/payments/${paymentId}/retry-journal-post`,
        SKIP_JOURNAL_POST: (paymentId: string) => `${BASE_URL}/payroll/payments/${paymentId}/skip-journal-post`,
        RECORD_BATCH: `${BASE_URL}/payroll/payments/batches`,
        VOID_BATCH: (batchId: string) => `${BASE_URL}/payroll/payments/batches/${batchId}/void`,
        LIST_BATCHES: `${BASE_URL}/payroll/payments/batches`,
        RECONCILIATION: `${BASE_URL}/payroll/payments/reconciliation`,
        SEGMENT: (id: string) => `${BASE_URL}/payroll/${id}/segment`,
        BULK_SEGMENT: `${BASE_URL}/payroll/segment`,
    },
    TAX_SETTINGS: {
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/tax-settings/institution/${institutionId}`,
        UPSERT: `${BASE_URL}/tax-settings`,
    },
    TAX_YEAR: {
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/tax-year/institution/${institutionId}`,
        SAVE: `${BASE_URL}/tax-year`,
        ACTIVATE: (id: string) => `${BASE_URL}/tax-year/${id}/activate`,
        DELETE: (id: string) => `${BASE_URL}/tax-year/${id}`,
    },
    TAX_EXEMPTION: {
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/tax-exemption/institution/${institutionId}`,
        SAVE_ALL: (institutionId: string) => `${BASE_URL}/tax-exemption/institution/${institutionId}/save-all`,
    },
    EMPLOYEE_TAX: {
        SUMMARY: (institutionId: string, taxYearId: string) =>
            `${BASE_URL}/employee-tax/institution/${institutionId}/tax-year/${taxYearId}`,
    },
    TAX_REPORT: {
        MONTHLY: (institutionId: string, taxYearId: string) =>
            `${BASE_URL}/tax-report/institution/${institutionId}/tax-year/${taxYearId}/monthly`,
        MONTHLY_PDF: (institutionId: string, taxYearId: string) =>
            `${BASE_URL}/tax-report/institution/${institutionId}/tax-year/${taxYearId}/monthly/pdf`,
        CERTIFICATE_PDF: (institutionId: string, taxYearId: string, userId: string) =>
            `${BASE_URL}/tax-report/institution/${institutionId}/tax-year/${taxYearId}/certificate/${userId}/pdf`,
    },
    SHIFT: {
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/shifts/institution/${institutionId}`,
        BY_ID: (institutionId: string, id: string) => `${BASE_URL}/shifts/institution/${institutionId}/${id}`,
        ASSIGNMENTS_BY_INSTITUTION: (institutionId: string) =>
            `${BASE_URL}/shifts/institution/${institutionId}/assignments`,
        ASSIGNMENT_BY_ID: (institutionId: string, id: string) =>
            `${BASE_URL}/shifts/institution/${institutionId}/assignments/${id}`,
        ASSIGNMENTS_BULK: (institutionId: string) =>
            `${BASE_URL}/shifts/institution/${institutionId}/assignments/bulk`,
        ME_TODAY: `${BASE_URL}/shifts/me/today`,
        ME_UPCOMING: `${BASE_URL}/shifts/me/upcoming`,
        ROTATION_PATTERNS: (institutionId: string) =>
            `${BASE_URL}/shifts/institution/${institutionId}/rotation-patterns`,
        ROTATION_PATTERN_BY_ID: (institutionId: string, id: string) =>
            `${BASE_URL}/shifts/institution/${institutionId}/rotation-patterns/${id}`,
        ROSTER: (institutionId: string) =>
            `${BASE_URL}/shifts/institution/${institutionId}/roster`,
        ROSTER_OVERRIDE: (institutionId: string, instanceId: string) =>
            `${BASE_URL}/shifts/institution/${institutionId}/roster/override/${instanceId}`,
        ROSTER_RESET: (institutionId: string, instanceId: string) =>
            `${BASE_URL}/shifts/institution/${institutionId}/roster/reset/${instanceId}`,
        ROSTER_BULK_SWAP: (institutionId: string) =>
            `${BASE_URL}/shifts/institution/${institutionId}/roster/bulk-swap`,
        ROSTER_REGENERATE: (institutionId: string) =>
            `${BASE_URL}/shifts/institution/${institutionId}/roster/regenerate`,
        ORPHANS: (institutionId: string) =>
            `${BASE_URL}/shifts/institution/${institutionId}/orphan-punches`,
        ORPHAN_ATTACH: (institutionId: string, id: string) =>
            `${BASE_URL}/shifts/institution/${institutionId}/orphan-punches/${id}/attach`,
        ORPHAN_DELETE: (institutionId: string, id: string) =>
            `${BASE_URL}/shifts/institution/${institutionId}/orphan-punches/${id}`,
    },
    EXPENSE_CATEGORY: {
        BASE: `${BASE_URL}/expense-category`,
        LIST_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/expense-category/institution/${institutionId}`,
        GET_BY_ID: (id: string, institutionId: string) => `${BASE_URL}/expense-category/${id}/institution/${institutionId}`,
        CREATE: `${BASE_URL}/expense-category`,
        UPDATE: (id: string) => `${BASE_URL}/expense-category/${id}`,
        DELETE: (id: string, institutionId: string) => `${BASE_URL}/expense-category/${id}/institution/${institutionId}`,
    },
    EXPENSE_POLICY: {
        GET_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/expense-policy/institution/${institutionId}`,
        UPSERT: `${BASE_URL}/expense-policy`,
        ADD_TIER: (institutionId: string) => `${BASE_URL}/expense-policy/institution/${institutionId}/tiers`,
        UPDATE_TIER: (id: string) => `${BASE_URL}/expense-policy/tiers/${id}`,
        DELETE_TIER: (id: string) => `${BASE_URL}/expense-policy/tiers/${id}`,
    },
    EXPENSE_CLAIM: {
        CREATE: `${BASE_URL}/expense-claim`,
        UPDATE: (id: string) => `${BASE_URL}/expense-claim/${id}`,
        GET_BY_ID: (id: string) => `${BASE_URL}/expense-claim/${id}`,
        SUBMIT: (id: string) => `${BASE_URL}/expense-claim/${id}/submit`,
        RECALL: (id: string) => `${BASE_URL}/expense-claim/${id}/recall`,
        DELETE: (id: string) => `${BASE_URL}/expense-claim/${id}`,
        LIST_MINE: (institutionId: string) => `${BASE_URL}/expense-claim/mine/institution/${institutionId}`,
        APPROVE: (id: string) => `${BASE_URL}/expense-claim/${id}/approve`,
        REJECT: (id: string) => `${BASE_URL}/expense-claim/${id}/reject`,
        EDIT_LINE: (id: string, lineId: string) => `${BASE_URL}/expense-claim/${id}/lines/${lineId}`,
        REMOVE_LINE: (id: string, lineId: string) => `${BASE_URL}/expense-claim/${id}/lines/${lineId}`,
        PENDING_APPROVAL: (institutionId: string) => `${BASE_URL}/expense-claim/pending-approval/institution/${institutionId}`,
        PAY_STANDALONE: (id: string) => `${BASE_URL}/expense-claim/${id}/pay-standalone`,
        LINK_ADVANCE: (id: string, advanceId: string) => `${BASE_URL}/expense-claim/${id}/link-advance/${advanceId}`,
        UNLINK_ADVANCE: (id: string) => `${BASE_URL}/expense-claim/${id}/link-advance`,
        LIST_ALL: (institutionId: string) => `${BASE_URL}/expense-claim/all/institution/${institutionId}`,
    },
    EXPENSE_ADVANCE: {
        REQUEST: `${BASE_URL}/expense-advance`,
        GET_BY_ID: (id: string) => `${BASE_URL}/expense-advance/${id}`,
        APPROVE: (id: string) => `${BASE_URL}/expense-advance/${id}/approve`,
        REJECT: (id: string) => `${BASE_URL}/expense-advance/${id}/reject`,
        PAY: (id: string) => `${BASE_URL}/expense-advance/${id}/pay`,
        LIST_MINE: (institutionId: string) => `${BASE_URL}/expense-advance/mine/institution/${institutionId}`,
        PENDING_APPROVAL: (institutionId: string) => `${BASE_URL}/expense-advance/pending-approval/institution/${institutionId}`,
    },
    FIXED_ASSET: {
        BASE: `${BASE_URL}/fixed-asset`,
        LIST_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/fixed-asset/institution/${institutionId}`,
        GET_BY_ID: (id: string) => `${BASE_URL}/fixed-asset/${id}`,
        CREATE: `${BASE_URL}/fixed-asset`,                       // new-purchase (posts JE)
        REGISTER: `${BASE_URL}/fixed-asset/register`,            // register-existing (opening JE)
        UPDATE: (id: string) => `${BASE_URL}/fixed-asset/${id}`,
        DELETE: (id: string) => `${BASE_URL}/fixed-asset/${id}`,
        DISPOSE: (id: string) => `${BASE_URL}/fixed-asset/${id}/dispose`,
        DISPOSE_REVERSE: (id: string) => `${BASE_URL}/fixed-asset/${id}/dispose-reverse`,
    },
    FIXED_ASSET_DEPRECIATION: {
        RUN: (institutionId: string) => `${BASE_URL}/fixed-asset-depreciation/run/${institutionId}`,
        SCHEDULE_BY_ASSET: (assetId: string) => `${BASE_URL}/fixed-asset-depreciation/asset/${assetId}`,
    },
    FIXED_ASSET_SETTINGS: {
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/fixed-asset-settings/institution/${institutionId}`,
        UPSERT: `${BASE_URL}/fixed-asset-settings`,
    },
    FIXED_ASSET_REPORT: {
        REGISTER: (institutionId: string) => `${BASE_URL}/fixed-asset-report/register/institution/${institutionId}`,
        SCHEDULE: (institutionId: string) => `${BASE_URL}/fixed-asset-report/schedule/institution/${institutionId}`,
        TIE_OUT: (institutionId: string) => `${BASE_URL}/fixed-asset-report/tie-out/institution/${institutionId}`,
    },
    SUBSCRIPTION_INVOICE: {
        BASE: `${BASE_URL}/subscription-invoice`,
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/subscription-invoice/institution/${institutionId}`,
        ISSUE: (id: string) => `${BASE_URL}/subscription-invoice/${id}/issue`,
        CANCEL: (id: string) => `${BASE_URL}/subscription-invoice/${id}/cancel`,
        MARK_PAID: (id: string) => `${BASE_URL}/subscription-invoice/${id}/mark-paid`,
        PAY_BKASH: (id: string) => `${BASE_URL}/subscription-invoice/${id}/pay/bkash`,
        RESOLVE_PAYMENT: (paymentId: string) => `${BASE_URL}/subscription-invoice/payment/${paymentId}/resolve`,
        MARK_REFUNDED: (paymentId: string) => `${BASE_URL}/subscription-invoice/payment/${paymentId}/refunded`,
    },
} as const;
